import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { defaultSeo, getSeoForPath } from './routeSeo';

function ensureMetaTag(key, value, attribute = 'name') {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute('content', value);
}

function ensureLinkTag(rel, href) {
  let element = document.head.querySelector(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }

  element.setAttribute('href', href);
}

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const seo = getSeoForPath(location.pathname) || defaultSeo;
    const keywords = Array.isArray(seo.keywords)
      ? seo.keywords.filter(Boolean).join(', ')
      : '';

    document.title = seo.title || defaultSeo.title;
    ensureMetaTag(
      'description',
      seo.description || defaultSeo.description
    );
    ensureMetaTag('keywords', keywords);
    ensureMetaTag('og:title', seo.title || defaultSeo.title, 'property');
    ensureMetaTag(
      'og:description',
      seo.description || defaultSeo.description,
      'property'
    );
    ensureMetaTag('twitter:title', seo.title || defaultSeo.title);
    ensureMetaTag(
      'twitter:description',
      seo.description || defaultSeo.description
    );
    ensureMetaTag('twitter:card', 'summary_large_image');
    ensureMetaTag('og:type', 'website', 'property');
    ensureMetaTag('robots', 'index, follow');
    ensureLinkTag(
      'canonical',
      `${window.location.origin}${location.pathname}`
    );
  }, [location.pathname]);

  return null;
}
